namespace GeniuzPOS.Purchase {
    export class ListAppPurInvoiceColumns {
        static columnsKey = 'Purchase.ListAppPurInvoice';
    }
}
